import { WidgetCard } from "app/Components/EhsDashboard/Global/Widgets";
import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import RightFilter from "../RightFilter";
import { GlobalDashboardService } from "app/_services/GlobalDashboardService/GlobalDashboardService";
import PieChartWithModal from "app/Components/PieChartWithModal/PieChartWithModal";
import {
  BarChartCard,
  BasicBarChartCardWithCustomToolTip,
  BasicBarChartWithLabelCard,
  BodyChartCard,
  FunnelChartCard,
  MultipleBarChartCard,
  StackBarChartCard,
} from "app/Components/ChartCard/ChartCard";
import {
  pageTwoChartList,
  pageOneChartList,
  widgetData,
  pyramidKeyColour,
} from "./Constant";
import DashboardNav from "../Comman/DashboardNav";
import {
  barChartDataFormat,
  basicBarChartWithCustomTooltipDataFormat,
  BasicBarChartWithLabelDataFormat,
  pieChartDataWithModal,
  pieChartDataWithModalForTotalVs,
  pyramidChartDataFormat,
  pyramidIncidentType,
  stackChartDataFormat,
} from "../Comman/config";
import {
  IS_USER_SITE_HO,
  IS_USER_SITE_MINES,
  IS_USER_SITE_RO,
} from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Helper";
import { useSelector } from "react-redux";
import { getAllSites, getAllSitesWithAccess } from "app/_services/ehs/ehsSiteServices";
import { useMemo } from "react";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
const IncidentManagementDashboard = () => {
  // const [form, setForm] = useState({ ...initialForm });
  const [showFilter, setShowFilter] = useState(false);
  const [page, setPage] = useState(1);
  const [chart, setChart] = useState({});
  const [allSite, setAllSite] = useState([]);
  const [haveAccessToSite, setHaveAccessToSite] = useState([]);
  const [currentSelectedSite, setCurrentSelectedSite] = useState({});
  const [loading, setLoading] = useState(true);
  // const [globalSelectedSiteId, setGlobalSelectedSiteId] = useState("");

  const customLavel = useMemo(() => {
    return {
      Fatality: {
        style: {
          width: "30px",
          height: "16px",
          background: "#DC143C",
          borderRadius: "4px",
          display: "inline-block",
          marginRight: "8px",
        },
        name: "Fatality",
      },
      "Serious Bodily Injury": {
        style: {
          width: "30px",
          height: "16px",
          background: "#808000",
          borderRadius: "4px",
          display: "inline-block",
          marginRight: "8px",
        },
        name: "SBI",
      },
      LTI: {
        style: {
          width: "30px",
          height: "16px",
          background: "#6495ED",
          borderRadius: "4px",
          display: "inline-block",
          marginRight: "8px",
        },
        name: "LTI",
      },
      "NM + MTI": {
        style: {
          width: "30px",
          height: "16px",
          background: "#D2691E",
          borderRadius: "4px",
          display: "inline-block",
          marginRight: "8px",
        },
        name: "NM + MTI",
      },
      "UA + UC": {
        style: {
          width: "30px",
          height: "16px",
          background: "#90EE90",
          borderRadius: "4px",
          display: "inline-block",
          marginRight: "8px",
        },
        name: "UA + UC",
      },
    };
  });

  const [chartData, setChartData] = useState({});

  const filterClick = (value) => {
    setShowFilter(value);
  };
  const globalSelectedSiteId = useSelector((state) => state.userData?.siteIds);
  // console.log("//*/*/globalSelectedSiteId", globalSelectedSiteId);
  // const onClick = useCallback(({ target: { innerText } }) => {
  //   setForm((prev) => ({ ...prev, dashboardSelect: innerText }));
  // }, []);
  useEffect(() => {
    getAllSitesWithAccess().then((res) => {
      setAllSite(res?.data?.availableSites);
    });
    // console.log("/**/**/*incidentDAshboard");
  }, []);

  useEffect(() => {
    const getSiteData = allSite?.find((d) => d.id == globalSelectedSiteId);
    setCurrentSelectedSite(getSiteData);
    pageValueFun(1);
    const haveAccessToSiteArray = !getSiteData
      ? []
      : getSiteData?.siteType == 1
      ? allSite?.map((d) => {
          return d.id;
        })
      : getSiteData?.siteType == 2
      ? allSite
          ?.filter((d) => {
            if (d.id == globalSelectedSiteId || d.parentSiteId == globalSelectedSiteId)
              return d.id;
          })
          .map((d) => {
            return d.id;
          })
      : getSiteData?.siteType == 3
      ? allSite
          ?.filter((d) => {
            if (d.id == globalSelectedSiteId) return d.id;
          })
          .map((d) => {
            return d.id;
          })
      : [];

    setHaveAccessToSite(haveAccessToSiteArray);
    // console.log("/*/****/*/siteArraty");
  }, [allSite, globalSelectedSiteId]);

  const dashboardData = useCallback(
    async (filter) => {
      let obj = {
        startDate: filter?.startDate,
        endDate: filter?.endDate,
        siteId: filter?.siteId
          ? filter?.siteId
          : haveAccessToSite
          ? haveAccessToSite
          : null,
      };
      // console.log("88888888888", obj);
      // console.log("globalSelectedSiteId+++++", globalSelectedSiteId);
      // console.log("haveAccessToSite", haveAccessToSite);
      // console.log("currentSelectedSite", currentSelectedSite);
      if (JSON.stringify(obj) === JSON.stringify({ siteId: [] })) {
        return;
      }

      let response = await GlobalDashboardService.incidentDashboard(obj);
      // console.log("/*/****/*/dashboard");
      if (response && response.status && response.data) {
        const dashboardData = response.data;
        let holdNull = pageOneChartList?.map((item) => {
          setChart((prev) => ({
            ...prev,
            [item?.value]:
              item?.type == "stack"
                ? stackChartDataFormat(dashboardData[item?.value])
                : item?.type == "bar"
                ? barChartDataFormat(dashboardData[item?.value])
                : item?.type == "barWithLabel"
                ? BasicBarChartWithLabelDataFormat(dashboardData[item?.value])
                : item?.type == "pieVs"
                ? pieChartDataWithModalForTotalVs(dashboardData[item?.value])
                : item?.type == "pie"
                ? pieChartDataWithModal(dashboardData[item?.value])
                : "No chart",
          }));
        });

        // return;

        let holdNulll = pageTwoChartList?.map((item) => {
          setChart((prev) => ({
            ...prev,
            [item?.value]:
              item?.type == "stack"
                ? stackChartDataFormat(dashboardData[item?.value])
                : item?.type == "barWithCustomTooltip"
                ? basicBarChartWithCustomTooltipDataFormat(dashboardData[item?.value])
                : item?.type == "bar"
                ? barChartDataFormat(dashboardData[item?.value])
                : item?.type == "pie"
                ? pieChartDataWithModal(dashboardData[item?.value])
                : item?.type == "pyramid"
                ? pyramidChartDataFormat(dashboardData[item?.value])
                : item?.type == "bodyPart"
                ? dashboardData[item?.value]
                : "No chart",
          }));
        });

        setChart((prev) => ({
          ...prev,
          dashboardData: dashboardData,
          widgetData: widgetData?.map((item) => {
            return {
              value: dashboardData[item?.value],
              name: item?.name,
              icon: item?.icon,
            };
          }),
        }));
      }
      setLoading(false);
    },
    [haveAccessToSite]
  );

  const pageValueFun = (value) => {
    setPage(value);
  };
  useEffect(() => {
    dashboardData();
  }, [dashboardData]);

  const applyFilter = (filter) => {
    dashboardData(filter);
  };

  return (
    <>
      <Row>
        <Col lg={showFilter ? 9 : 12}>
          <Row>
            <Col lg={12}>
              <DashboardNav
                screenCount={
                  (globalSelectedSiteId && currentSelectedSite?.siteType == 3
                    ? true
                    : false) || IS_USER_SITE_MINES()
                    ? 1
                    : 2
                }
                pageBool={pageValueFun}
                onFilterBool={filterClick}
                page={page}
                dashboardName="Incident Management"
                id={"screen_" + page}
              />
            </Col>
          </Row>
          {!loading ? (
            <>
              {" "}
              {!IS_USER_SITE_MINES() &&
                (globalSelectedSiteId ? currentSelectedSite?.siteType != 3 : true) &&
                page == 1 && (
                  <Row className="screenOne" id={"screen_" + page}>
                    {pageOneChartList?.map((item, idx) => {
                      if (IS_USER_SITE_HO()) {
                        return item?.type == "stack" ? (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            className="mb-4 pb-2"
                          >
                            <StackBarChartCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              categoryData={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        ) : item?.type == "bar" ? (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            className="mb-4 pb-2"
                          >
                            <MultipleBarChartCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              category={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        ) : item?.type == "barWithLabel" ? (
                          <Col lg={6} id={"main_" + idx} className="mb-4 pb-2">
                            <BasicBarChartWithLabelCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              category={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        ) : (
                          <Col key={idx} md={6} id={"main_" + idx} className="mb-4 pb-2">
                            <PieChartWithModal
                              title={item.title}
                              id={"main_" + idx}
                              seriesData={chart[item?.value] || []}
                              customLabelFalse={true}
                              isCustomLegend={true}
                            />
                          </Col>
                        );
                      } else if (!item?.isHo && !IS_USER_SITE_HO()) {
                        return item?.type == "stack" ? (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            className="mb-4 pb-2"
                          >
                            <StackBarChartCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              categoryData={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        ) : item?.type == "bar" ? (
                          <Col
                            lg={item?.isMines ? 12 : 6}
                            id={"main_" + idx}
                            className="mb-4 pb-2"
                          >
                            <MultipleBarChartCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              category={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        ) : item?.type == "barWithLabel" ? (
                          <Col lg={6} id={"main_" + idx} className="mb-4 pb-2">
                            <BasicBarChartWithLabelCard
                              title={item?.name}
                              id={"main_" + idx}
                              yAxisName={item?.yAxisName}
                              xAxisName={item?.xAxisName}
                              category={chart[item?.value]?.categoryData}
                              seriesData={chart[item?.value]?.data}
                            />
                          </Col>
                        ) : (
                          <Col key={idx} id={"main_" + idx} md={6} className="mb-4 pb-2">
                            <PieChartWithModal
                              pieChartColour={
                                item?.value === "overdueCAPAsHO"
                                  ? ["#d90028", "#f5cb39"]
                                  : false
                              }
                              title={item.title}
                              id={"main_" + idx}
                              seriesData={chart[item?.value] || []}
                              customLabelFalse={true}
                              isCustomLegend={true}
                            />
                          </Col>
                        );
                      }
                    })}
                  </Row>
                )}
              {(((IS_USER_SITE_MINES() ||
                (globalSelectedSiteId && currentSelectedSite?.siteType == 3
                  ? true
                  : false)) &&
                page == 1) ||
                page == 2) && (
                <Row id={"screen_" + page}>
                  <Col lg={12}>
                    <div className="ohscContainer">
                      <div className="widgetContainer mt-3">
                        <WidgetCard
                          isFilterClick={showFilter}
                          widgetData={chart?.widgetData}
                        />
                      </div>

                      <div className="chartContainer">
                        <Row>
                          {pageTwoChartList.map((item, idx) =>
                            item?.type == "stack" ? (
                              <Col lg={6} id={"main_" + idx} className="mb-4 pb-2">
                                <StackBarChartCard
                                  title={item?.name}
                                  id={"main_" + idx}
                                  yAxisName={item?.yAxisName}
                                  xAxisName={item?.xAxisName}
                                  categoryData={chart[item?.value]?.categoryData}
                                  seriesData={chart[item?.value]?.data}
                                />
                              </Col>
                            ) : item?.type == "barWithCustomTooltip" ? (
                              <Col
                                lg={item?.isMines ? 12 : 6}
                                id={"main_" + idx}
                                className="mb-4 pb-2"
                              >
                                <BasicBarChartCardWithCustomToolTip
                                  title={item?.name}
                                  id={"main_" + idx}
                                  yAxisName={item?.yAxisName}
                                  xAxisName={item?.xAxisName}
                                  category={chart[item?.value]?.categoryData}
                                  seriesData={chart[item?.value]?.data}
                                  customToolTip={chart[item?.value]?.dataList}
                                />
                              </Col>
                            ) : item?.type == "bar" ? (
                              <Col lg={6} id={"main_" + idx} className="mb-4 pb-2">
                                <MultipleBarChartCard
                                  title={item?.name}
                                  id={"main_" + idx}
                                  yAxisName={item?.yAxisName}
                                  xAxisName={item?.xAxisName}
                                  category={chart[item?.value]?.categoryData}
                                  seriesData={chart[item?.value]?.data}
                                />
                              </Col>
                            ) : item?.type == "pyramid" ? (
                              <Col lg={6} id={"main_" + idx} className="mb-4 pb-2">
                                <FunnelChartCard
                                  title={item?.title}
                                  height="490px"
                                  id={"main_" + idx}
                                  //legend={chart[item?.value]?.categoryData}
                                  seriesData={chart[item?.value]?.data}
                                />
                                <div style={{ marginTop: "-50px" }}>
                                  <Col
                                    style={
                                      {
                                        // overflow: "auto",
                                        // paddingLeft: "50px",
                                      }
                                    }
                                    md={12}
                                  >
                                    <div
                                      style={{ paddingLeft: "94px" }}
                                      className="d-flex justify-content-center"
                                    >
                                      {chart[item?.value]?.data?.map((d) => {
                                        return (
                                          <label className="d-flex align-items-center mr-2">
                                            <span
                                              style={customLavel[d.name]?.style}
                                            ></span>
                                            <span> {customLavel[d.name]?.name}</span>
                                          </label>
                                        );
                                      })}
                                    </div>
                                  </Col>
                                </div>
                              </Col>
                            ) : item?.type == "bodyPart" ? (
                              <Col lg={6} id={"main_" + idx} className="mb-4 pb-2">
                                <BodyChartCard
                                  title={item?.name}
                                  id={"main_" + idx}
                                  bodyData={chart[item?.value]}
                                />
                              </Col>
                            ) : (
                              <Col
                                key={idx}
                                id={"main_" + idx}
                                md={6}
                                className="mb-4 pb-2"
                              >
                                <PieChartWithModal
                                  title={item.title}
                                  id={"main_" + idx}
                                  seriesData={chart[item?.value] || []}
                                  customLabelFalse={true}
                                  isCustomLegend={true}
                                />
                              </Col>
                            )
                          )}
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>
              )}
            </>
          ) : (
            <NetZeroLoader addZIndex={true} />
          )}
        </Col>
        <Col lg={2} className={`d-${showFilter ? "block" : "none"}`}>
          <RightFilter applyFilter={applyFilter} />
        </Col>
      </Row>
    </>
  );
};

export default IncidentManagementDashboard;
